import React from "react";

function LockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
    >
      <g
        id="Group_33160"
        data-name="Group 33160"
        transform="translate(0.223 0.001)"
      >
        <path
          id="Image_626"
          data-name="Image 626"
          d="M0,0H21a4,4,0,0,1,4,4V25a0,0,0,0,1,0,0H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z"
          transform="translate(-0.223 -0.001)"
          fill="#0f0f0f"
          opacity="0.721"
        />
        <path
          id="Path_22411"
          data-name="Path 22411"
          d="M13.725,7.362h.67a.67.67,0,0,1,.67.67v6.7a.67.67,0,0,1-.67.67H3.67a.67.67,0,0,1-.67-.67v-6.7a.67.67,0,0,1,.67-.67h.67v-.67a4.692,4.692,0,1,1,9.384,0Zm-1.341,0v-.67a3.351,3.351,0,1,0-6.7,0v.67ZM8.362,10.043v2.681H9.7V10.043Z"
          transform="translate(2.284 3.44)"
          fill="#fafafa"
        />
      </g>
    </svg>
  );
}

export default LockIcon;
